import { I18n } from '@front/volcanion'

class Callbacks {
  static onSubmitHandler(searchUser, setFormState, setFormValues) {
    return async function onSubmit(values) {
      const { identifier, pin } = values
      const [user] = await searchUser({ user_companies: { identifier, pin } })
      if (!user) {
        throw new Error(I18n.t('user.identifier_pin.not_found'))
      }
      setFormState({ isB2B: true, user_id: user.user_id })
      setFormValues([{ field: 'user.gsm', value: user.auth.gsm }])
    }
  }
  static getFailedNotificationHandler() {
    return function getFailedNotification(err) {
      return [err?.message, { variant: 'error' }]
    }
  }
}


export default Callbacks
